import { BaseResponse } from "../BaseResponse";

export class MakePasswordPrivateResponse extends BaseResponse {

}